import { ClockModule } from '../shared/clock/clock.module';
import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { FooterComponent } from './footer/footer.component';
import { FormsModalConfirmationModule } from '../forms-modal-confirmation/forms-modal-confirmation.module';
import { FormsModalModule } from '../forms-modal/forms-modal.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HorizontalComponent } from './horizontal/horizontal.component';
import { HorizontalTopbarComponent } from './horizontal-topbar/horizontal-topbar.component';
import { LanguageService } from '../core/services/language.service';
import { LayoutComponent } from './layout.component';
import { NgbCollapseModule, NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { NgbDropdownModule, NgbNavModule } from '@ng-bootstrap/ng-bootstrap';
import { PageComponentsModule } from '../core/page-components/page-components.module';
import { RightsidebarComponent } from './rightsidebar/rightsidebar.component';
import { RouterModule } from '@angular/router';
import { SidebarComponent } from './sidebar/sidebar.component';
import { SimplebarAngularModule } from 'simplebar-angular';
import { TopbarComponent } from './topbar/topbar.component';
import { TopbarSearchComponent } from './topbar-search/topbar-search.component';
import { TranslateModule } from '@ngx-translate/core';
import { TwoColumnComponent } from './two-column/two-column.component';
import { TwoColumnSidebarComponent } from './two-column-sidebar/two-column-sidebar.component';
import { VerticalComponent } from './vertical/vertical.component';

@NgModule({
  declarations: [
    FooterComponent,
    HorizontalComponent,
    HorizontalTopbarComponent,
    LayoutComponent,
    RightsidebarComponent,
    SidebarComponent,
    TopbarComponent,
    TopbarSearchComponent,
    TwoColumnSidebarComponent,
    TwoColumnComponent,
    VerticalComponent

  ],
  imports: [
    ClockModule,
    CommonModule,
    FormsModalConfirmationModule,
    FormsModalModule,
    FormsModule,
    NgbCollapseModule,
    NgbDropdownModule,
    NgbNavModule,
    NgbTooltipModule,
    PageComponentsModule,
    RouterModule,
    ReactiveFormsModule,
    SimplebarAngularModule,
    TranslateModule
  ],
  schemas: [
    CUSTOM_ELEMENTS_SCHEMA
  ],
  providers: [
    LanguageService
  ]
})
export class LayoutsModule { }
